var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53917 13.8283L6.42992 11.6725L7.4543 10.6255L8.5691 11.7642L11.5744 8.69336L12.569 9.70983L8.53917 13.8283ZM7.68773 3.26879C7.68773 2.77648 8.07508 2.24 8.72408 2.24H10.3617C11.0106 2.24 11.3108 2.76192 11.3108 3.26399V6.55996H7.68773V3.26879ZM14.6394 6.59097L14.6322 6.55993H13.5164V3.26397C13.5164 3.13757 13.6848 0 10.3518 0H8.72439C5.38723 0 5.50411 3.19997 5.50978 3.35997H5.48269V6.55993H4.4383C3.84774 6.55993 3.27734 7.09561 3.27734 7.6956V14.8637V14.8922C3.27734 15.4918 3.84758 16 4.4383 16H14.6322H14.6568C15.2473 15.9998 15.7218 15.492 15.7218 14.892V14.8635V7.6956C15.7218 7.09545 15.2302 6.59097 14.6394 6.59097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.112ba82949cba741731b0ed1b0b79689.svg";
export { ForwardRef as ReactComponent };